










import { Component, Vue, Prop, Model } from 'vue-property-decorator';

@Component
export default class BaseSelect extends Vue {
  @Model('change') private value!: string | number;
  @Prop({ default: () => [] }) private options!: string[];
  /** Если в качестве value опций используем индекс */
  @Prop({ default: false, type: Boolean }) private indexAsValue!: boolean;

  private optionValue(index: number, opt: string): string | number {
    return this.indexAsValue ? index : opt;
  }

  /** Сохраняем типизацию, т.к из ивента нам всегда приходит строка */
  private onChange(newVal: string): void {
    let res: string | number = newVal;
    if (typeof this.value === 'number') {
      res = parseInt(newVal, 10);
    }
    this.$emit('change', res);
  }
}
